var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs pl-2"},[_vm._l((_vm.views),function(view){return [((view == 'report' && _vm.input && _vm.input.is_draft == false) || view != 'report')?_c('div',{key:view,staticClass:"tab px-2",class:{ active: view == _vm.currentView },style:({
        'background-color': view == _vm.currentView ? _vm.$vuetify.theme.primary : 'transparent',
        cursor: 'pointer'
      }),on:{"click":function($event){return _vm.handleChangeView(view)}}},[_vm._v("\n      "+_vm._s(view)+"\n    ")]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c18fe7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/generalixwarroom/GameSetting/GameSettingTab.vue
// module id = null
// module chunks = 